import { StatusBadge } from './StatusBadge';
import { resolveStatusTone } from '../../utils/statusBadge';

type CodedStatusBadgeProps = {
  status: string;
  label?: string;
  className?: string;
};

/** Badge para status tipados (enums), com tom derivado do código. */
export function CodedStatusBadge({ status, label, className }: CodedStatusBadgeProps) {
  return (
    <StatusBadge tone={resolveStatusTone(status)} className={className}>
      {label ?? status}
    </StatusBadge>
  );
}
